/* tslint:disable */
import { MeshGeneration } from './mesh-generation';
import { ProductElmt } from './product-elmt';
import { MeshPosition } from './mesh-position';

/**
 */
export class ViewMesh {
    meshGeneration?: MeshGeneration;
    elements?: ProductElmt[];
    elmtMeshPositions?: MeshPosition[];
    productIsoTemp?: number;
    averageProductTemp?: number;
    nbMeshPointElmt?: number[];
    productElmtInitTemp?: number[][];
    initTempPositions?: number[][];
    heights?: number[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-mesh.ts